import { render } from "./moduleDialogIconHelp.vue?vue&type=template&id=c0fd0bd2"
import script from "./moduleDialogIconHelp.vue?vue&type=script&lang=js"
export * from "./moduleDialogIconHelp.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__